import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";
import { db } from "@/firebase";

// Resolve the entity document from the URL brand. Primary lookup is by the
// `slug` field; if that finds nothing (e.g. the slug was edited in Firestore
// and no longer matches the URL), fall back to the document ID, which for our
// entities matches the brand path (/mx -> entities/mx). This keeps the pages
// loading even when the slug drifts.
async function resolveEntityDoc(brandName) {
  const q = query(collection(db, "entities"), where("slug", "==", brandName));
  const querySnapshot = await getDocs(q);
  let found = null;
  querySnapshot.forEach((d) => {
    found = d;
  });
  if (found) return found;
  const direct = await getDoc(doc(db, "entities", brandName));
  return direct.exists() ? direct : null;
}

export async function getEntity(brandName) {
  const entityDoc = await resolveEntityDoc(brandName);
  return entityDoc ? entityDoc.data() : undefined;
}

export async function getEntityItems(brandName) {
  const arr = [];
  const entityDoc = await resolveEntityDoc(brandName);
  if (!entityDoc) {
    console.error("getEntityItems: unknown entity", brandName);
    return arr;
  }
  const ref = query(
    collection(db, "entities/" + entityDoc.id + "/items"),
    where("img", "!=", null)
  );
  const snapshot = await getDocs(ref);
  snapshot.forEach((d) => {
    const data = d.data();
    data.uuid = d.id;
    arr.push(data);
  });
  return arr;
}

export async function getEntityItem(brandName, uuid) {
  const entityDoc = await resolveEntityDoc(brandName);
  if (!entityDoc) {
    console.error("getEntityItem: unknown entity", brandName);
    return undefined;
  }
  const ref = doc(db, "entities/" + entityDoc.id + "/items", uuid);
  const docSnap = await getDoc(ref);
  if (!docSnap.exists()) {
    console.error("getEntityItem: no such item", brandName, uuid);
    return undefined;
  }
  return docSnap.data();
}

export function injectModyScript({ entity, item, itemName, gender, assistant = false, vto = false, tag } = {}) {
  document.querySelector("script[data-mody]")?.remove();
  document.querySelector("[data-mody-assistant]")?.remove();
  window.modyInit = false;

  // The ecom-lib commerce adapter is initialized by the dynamically loaded
  // widget. Keep the host platform marker next to that injection so SPA
  // navigation and delayed script loading cannot lose the adapter selection.
  window.ModyEcom = { ...(window.ModyEcom || {}), platform: "mody-ecom" };

  const mody = document.createElement("script");
  const modyVersion = "2.10.67";
  const customSource = process.env.VUE_APP_MODY_SRC;
  if (customSource) {
    mody.setAttribute("src", customSource);
  } else {
    switch (process.env.VUE_APP_MODY_ENV) {
      case "mody-p":
        mody.setAttribute("src", `https://cdn.mody.ai?v=${modyVersion}`);
        break;
      case "mody-s":
        mody.setAttribute("src", `https://staging.cdn.mody.ai?v=${modyVersion}`);
        break;
      default:
        mody.setAttribute("src", `https://dev.cdn.mody.ai?v=${modyVersion}`);
    }
  }

  mody.setAttribute("data-mody", "");
  if (assistant) mody.setAttribute("data-assistant", "");
  if (vto) mody.setAttribute("data-vto", "");
  if (tag) mody.setAttribute("data-tag", tag);
  if (entity) mody.setAttribute("data-entity", entity);
  if (item) mody.setAttribute("data-item", item);
  if (itemName) mody.setAttribute("data-item-name", itemName);
  if (gender) mody.setAttribute("data-gender", gender);
  mody.setAttribute("defer", "defer");
  document.head.appendChild(mody);
}
